export const isBoardPage = (pathname) => {
  return pathname.includes('/board/');
};
